const GUEST_PROGRESS_STORAGE_KEY = "kewordal.games.guest-progress.v1";

export const clearGuestProgress = () => {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(GUEST_PROGRESS_STORAGE_KEY);
    window.localStorage.removeItem(GUEST_PROGRESS_STORAGE_KEY);
  } catch {
    // Best effort cleanup after a successful claim.
  }
};

export const readGuestProgress = () => {
  if (typeof window === "undefined") return null;
  try {
    const stored =
      window.sessionStorage.getItem(GUEST_PROGRESS_STORAGE_KEY) ||
      window.localStorage.getItem(GUEST_PROGRESS_STORAGE_KEY);
    const parsed = JSON.parse(stored || "null");
    if (!parsed || typeof parsed !== "object") return null;

    const expiresAt = parsed.claimExpiresAt
      ? new Date(parsed.claimExpiresAt).getTime()
      : null;
    if (Number.isFinite(expiresAt) && expiresAt <= Date.now()) {
      clearGuestProgress();
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const writeGuestProgress = (progress) => {
  if (typeof window === "undefined" || !progress) return;
  try {
    window.sessionStorage.setItem(
      GUEST_PROGRESS_STORAGE_KEY,
      JSON.stringify(progress),
    );
    window.localStorage.removeItem(GUEST_PROGRESS_STORAGE_KEY);
  } catch {
    // The backend cookie can still preserve the guest identity.
  }
};
